import React from 'react'
import { generatePath } from 'react-router-dom'

import moment from 'moment'

import { paths } from 'app/paths'

import { PoweredByGuidde } from './PoweredByGuidde'
import { getVideoDuration } from 'UI/Components'
import { firebaseConfig } from 'env'

type Props = {
    title: string
    userName: string
    uploadedAt: number
    counter: number
    videoDuration: number
    playbookId: string
    headerSize?: number
    headerAlignment?: 'left' | 'center'
}

export const Header = ({
    title,
    userName,
    uploadedAt,
    counter,
    videoDuration,
    playbookId,
    headerSize = 1,
    headerAlignment
}: Props) => {
    const generatedPath = generatePath(paths.playbookDetails, {
        playbookId
    })

    // Header size is translated to H1 H2 etc, up to H6
    const HeadTag = `h${headerSize > 6 ? '6' : headerSize}` as React.ElementType

    return (
        <div style={{ textAlign: headerAlignment ? headerAlignment : 'left' }}>
            <div>
                <HeadTag>
                    <a
                        href={`https://${firebaseConfig.authDomain}${generatedPath}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {title}
                    </a>
                </HeadTag>
                <PoweredByGuidde />
            </div>
            <div>&nbsp;</div>
            <div>
                {userName} &bull; {moment.unix(uploadedAt).format('MMM D, YYYY')}
            </div>
            <div>
                {counter} step{counter > 1 ? 's' : ''} &bull; {getVideoDuration(videoDuration)}
            </div>
            <div>&nbsp;</div>
        </div>
    )
}
